import React, { useState } from "react";
import { toast } from "react-toastify";
import TransactionPinModal from "../../../components/transaction-pin-modal/TransactionPinModal";
import { PaymentProcessor } from "../../../components";
import {
	useUploadBulkPurchaseCardMutation,
	useUploadBulkPurchaseWalletMutation,
} from "../../../../../service/bulk-purchase-service";
import { BulkLineItem, lineItemsToRequest } from "../../../../../model/bulk-purchase/bulk-purchase-customer";
import { BulkPaymentMethod } from "../../bulk-purchase.types";
import { ApplicationRoutes } from "../../../../../routes";
import { getErrorMessage } from "../../../../../utils/error-handler";

interface BulkTransactionPinProps {
	items: BulkLineItem[];
	method: BulkPaymentMethod;
	payLabel: string;
	onBack: () => void;
	onForgetPin: () => void;
	onSuccess: (reference: string) => void;
	onFailed: (reference: string) => void;
	onReferenceSet?: (reference: string) => void;
}

export const BulkTransactionPin: React.FC<BulkTransactionPinProps> = ({
	items,
	method,
	payLabel,
	onBack,
	onForgetPin,
	onSuccess,
	onFailed,
	onReferenceSet,
}) => {
	const [uploadWallet, { isLoading: isWalletLoading }] = useUploadBulkPurchaseWalletMutation();
	const [uploadCard, { isLoading: isCardLoading }] = useUploadBulkPurchaseCardMutation();
	const [showProcessor, setShowProcessor] = useState(false);
	const [paymentData, setPaymentData] = useState<{ paymentUrl?: string; reference: string; skipRedirect: boolean }>();

	const handleSubmit = async (pin: string) => {
		try {
			const requestItems = lineItemsToRequest(items);
			if (method === "wallet") {
				const reference = await uploadWallet({ pin, items: requestItems }).unwrap();
				setPaymentData({ reference: String(reference), skipRedirect: true });
			} else {
				const res = await uploadCard({
					pin,
					returnUrl: `${window.location.origin}/${ApplicationRoutes.CUSTOMER_BULK_PURCHASE}`,
					paymentTypes: ["Card"],
					items: requestItems,
				}).unwrap();
				setPaymentData({ reference: res.reference, paymentUrl: res.returnUrl, skipRedirect: false });
			}
			setShowProcessor(true);
		} catch (error: any) {
			toast.error(getErrorMessage(error?.data));
		}
	};

	if (showProcessor && paymentData) {
		return (
			<PaymentProcessor
				paymentUrl={paymentData.paymentUrl}
				reference={paymentData.reference}
				skipRedirect={paymentData.skipRedirect}
				onSuccess={reference => onSuccess(reference)}
				onFailed={reference => onFailed(reference)}
				onBack={() => setShowProcessor(false)}
				onReferenceSet={onReferenceSet}
			/>
		);
	}

	return (
		<TransactionPinModal
			submitText={payLabel}
			isSubmitting={isWalletLoading || isCardLoading}
			onSubmit={handleSubmit}
			onForgetPin={onForgetPin}
			onClose={onBack}
		/>
	);
};

export default BulkTransactionPin;
